import PropTypes from 'prop-types';
import React from 'react';
import Popup from 'views/shared/ui/popup';
import { roundPrice } from 'lib/pricing_utils';
import { FormattedMessage, injectIntl } from 'react-intl';

// const DefaultLabel = React.createClass({

//   displayName: 'CheckoutSummaryPricingDeposit',

//   render() {
//     return (
//       <span className="large">
//         <span className="label">
//           {t('DEPOSIT_DUE')}
//           <span className="icon af-help-circle" />
//           <br />{t('NOW')}
//         </span>
//       </span>
//     );
//   }
// });

class CheckoutSummaryPricingDeposit extends React.Component {
  static displayName = 'CheckoutSummaryPricingDeposit';

  static propTypes() {
    return {
      total_price: PropTypes.string.isRequired,
    };
  }

  popupContent = () => {
    if (this.props.popup_content) {
      return <span>{this.props.popup_content}</span>;
    }
    return (
      <span>
        <FormattedMessage
          id="THIS_BOOKING_REQUIRES_A_DEPOSIT_TO_COVER_UPFRONT_COSTS"
          defaultMessage="This booking requires a deposit to cover upfront costs"
        />
      </span>
    );
  };

  _renderPopup = () => {
    return (
      <Popup
        content={this.popupContent()}
        target=".DepositDue .af-help-circle"
        identifier="popup-CheckoutSummaryPricingDeposit"
      />
    );
  };

  render() {
    return (
      <div
        className="CheckoutSummary-ContentBox DepositDue"
        data-testid="depositDue"
      >
        <table className="section">
          <tbody>
            <tr>
              <td>
                <span className="large">
                  <span className="label">
                    <FormattedMessage
                      id="DEPOSIT_DUE_NOW"
                      defaultMessage="Deposit due <icon></icon> now"
                      values={{
                        icon: () => (
                          <span className="icon af-help-circle" />
                        ),
                      }}
                    />
                  </span>
                </span>
                {this._renderPopup()}
              </td>
              <td>
                <span className="large" data-testid="depositDueAmount">
                  {roundPrice(this.props.amount)}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default injectIntl(CheckoutSummaryPricingDeposit);
